import React, { useState, useEffect } from "react";
import * as S from "./styles";
import agente from "../../services/agents";
import _, { update } from "lodash";
import InputText from "../InputText";
import regional from "../../services/regional";
import convenio from "../../services/convenio";
import { mask } from "../../utils/mask";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const BorderedAutoCompleteSearchRoles = ({
  handleSearch,
  listRoles,
  initialValue,
  selected,
  label,
  title,
}) => {
  const [filtredValue, setFiltredValue] = useState("");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const handleOpen = () => {
    setOpen(!open);
  };

  const selection = (item) => {
    handleSearch(item);
    setFiltredValue(item?.nome);
    setOpen(false);
  };

  function handleFilter(e) {
    const value = e.target.value;
    setFiltredValue(e.target.value);

    if (!value || value === null || value === "") {
      setItems(
        listRoles?.map((item) => ({
          id: item?.id,
          nome: item?.nome,
        }))
      );
      handleSearch(null);
    } else {
      setItems(
        items?.filter(
          (item) => item?.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1
        )
      );
    }

    if (e && e.target.value.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  useEffect(() => {
    setItems(
      listRoles?.map(
        (item) =>
          ({
            id: item?.id,
            nome: item?.nome,
          } || [])
      )
    );
  }, [listRoles]);

  useEffect(() => {
    if (initialValue) {
      setFiltredValue(initialValue);
      handleSearch(initialValue);

      if (filtredValue.length > 3 && !selected) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }
  }, [initialValue]);

  return (
    <>
      <S.Wrapper>
        <S.Main>
          <S.Label>{title}</S.Label>
          <S.Select onClick={handleOpen}>
            <S.InputSearch
              placeholder={label}
              onChange={(e) => handleFilter(e)}
              value={filtredValue}
            />
            <S.ArrowInput>
              {open ? (
                <IoChevronDown size="3rem" />
              ) : (
                <IoChevronUp size="3rem" />
              )}
            </S.ArrowInput>
          </S.Select>
          {open && (
            <S.Options>
              {items?.map((item) => (
                <S.Option key={item.id} onClick={() => selection(item)}>
                  <S.Description>{item?.nome}</S.Description>
                </S.Option>
              ))}
            </S.Options>
          )}
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default BorderedAutoCompleteSearchRoles;
